import { render, staticRenderFns } from "./EditDetiled.vue?vue&type=template&id=5aeb0bad&scoped=true&"
import script from "./EditDetiled.vue?vue&type=script&lang=js&"
export * from "./EditDetiled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeb0bad",
  null
  
)

export default component.exports